import { useQuery } from '@tanstack/react-query';
import Queries from '../Common/Queries';
import { getVehicleCards } from '../Pages/Services/homeService';

export default function useGetVehicleCards() {
    return useQuery({
        queryKey: [Queries.GET_VEHICLE_CARDS],
        queryFn: () => getVehicleCards(),
        select: (data) => data.data || [],
        meta: { errorMessage: 'Failed to fetch vehicle cards' },
    });
}
